export default "__VITE_ASSET__k3eSbSyo__"